import {  FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";
import HelpAdornment from "./HelpAdornment";
import jobplatforms from '../../config/jobplatforms';

const options = Object.keys(jobplatforms).map(key => {
    return {
        value: key,
        text: jobplatforms[key]
    }
});

function JobPlatformSelect({
    value, 
    onChange,
    size,
    helperText,
    error=false,
    displayEmpty=false,
    hideHelpAdornment=false,
    placeholder="",
    label="Platform", 
    disabled=false, 
    required=true, 
}){
    const _options = required ? [...options] : [
        {value: 'any', text: 'Any'},
        ...options
    ];
    return<FormControl sx={{minWidth: 150}} fullWidth size="small">
        <InputLabel required={required} shrink={(displayEmpty && !!placeholder) || !!value} error={error} >{label} </InputLabel>
        <Select 
            error={error}
            disabled={disabled}
            displayEmpty={displayEmpty}
            size={size}
            fullWidth
            value={value || ""}
            label={label} 
            onChange={(e) => {onChange(e.target.value)}} 
            renderValue={v => {
                if(!v)
                    return placeholder;
                const o = options.find(o => o.value === v);
                return o ? o.text : "Any"
            }}
            endAdornment={hideHelpAdornment ? null : <HelpAdornment helpKey="jobPlatform" />}
        >
            {_options.map(o => { 
                return <MenuItem value={o.value} key={o.value}>{o.text}</MenuItem>            
            })}

        </Select>

        {helperText && <FormHelperText>{helperText}</FormHelperText>
}
    </FormControl>
}
export default JobPlatformSelect;